// Libs
import classNames from 'classnames/bind';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './BoxItemJobCosting.module.scss';

type Props = {
  data: {
    title?: string;
    subTitle?: string;
    value?: string;
    isWarning?: boolean;
  };
};

const cx = classNames.bind(styles);

const BoxItemJobCosting = (props: Props) => {
  //#region Destructuring Props
  const { data } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/jobs', 'common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Stack id='checkListJobTabComponent' className={cx('container', { isWarning: data.isWarning })}>
      <Typography className={cx('title')}>{data.title}</Typography>
      <Typography className={cx('value', { isWarning: data.isWarning })}>{data.value}</Typography>
      <Typography className={cx('subTitle')}>{data.subTitle}</Typography>
    </Stack>
  );
};

export default BoxItemJobCosting;
